<template>
  <div class="settings--content">
    <settings-section
      title="SendGrid"
      sub-title="Uses your inbox email as the From address (same as below). You only need an API key here; verify that sender or domain in SendGrid. Transactional Mail Send does not use a separate sender ID."
    >
      <form @submit.prevent="updateInbox">
        <label for="toggle-sendgrid">
          <input
            id="toggle-sendgrid"
            v-model="enabled"
            type="checkbox"
            name="toggle-sendgrid"
          />
          Enable SendGrid for this inbox
        </label>
        <div v-if="enabled" class="smtp-details-wrap">
          <woot-input
            v-model.trim="apiKey"
            type="password"
            class="medium-9 columns"
            label="API key"
            placeholder="SG.xxx"
          />
        </div>
        <woot-submit-button
          button-text="Update SendGrid"
          :loading="uiFlags.isUpdatingSendgrid"
          :disabled="uiFlags.isUpdatingSendgrid"
        />
      </form>
    </settings-section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import SettingsSection from 'dashboard/components/SettingsSection';

export default {
  components: {
    SettingsSection,
  },
  mixins: [alertMixin],
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      enabled: false,
      apiKey: '',
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  watch: {
    inbox() {
      this.setDefaults();
    },
  },
  mounted() {
    this.setDefaults();
  },
  methods: {
    setDefaults() {
      const sg = this.inbox.provider_config?.sendgrid || {};
      this.enabled = !!sg.enabled;
      this.apiKey = '';
    },
    async updateInbox() {
      const existing = { ...(this.inbox.provider_config || {}) };
      const prev = existing.sendgrid || {};
      if (this.enabled && !this.apiKey.trim() && !prev.api_key) {
        this.showAlert('Enter an API key or disable SendGrid.');
        return;
      }
      const merged = {
        ...existing,
        sendgrid: {
          enabled: this.enabled,
          api_key: this.apiKey.trim() || prev.api_key,
        },
      };
      try {
        await this.$store.dispatch('inboxes/updateInboxSendgrid', {
          id: this.inbox.id,
          channel: { provider_config: merged },
        });
        this.showAlert('SendGrid settings saved.');
      } catch (error) {
        this.showAlert('Could not save SendGrid settings.');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.smtp-details-wrap {
  margin-bottom: var(--space-medium);
}

.sender-email-hint {
  margin-bottom: var(--space-small);
}

.sender-email-value {
  margin-left: var(--space-smaller);
  word-break: break-all;
}

.hint-secondary {
  font-size: 0.875rem;
  opacity: 0.85;
  margin-bottom: var(--space-medium);
}
</style>
